import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIgpCalculatorLoader = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 300 58.33333",
	preserveAspectRatio: "xMidYMid",
	width: 72,
	height: 14,
	style: {
		shapeRendering: "auto",
		display: "block",
		background: "transparent"
	},
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("rect", {
			ry: 3,
			rx: 3,
			height: 30,
			width: 30,
			y: 15,
			x: 15,
			fill: "currentColor",
			children: /* @__PURE__ */ _jsx("animate", {
				begin: "0s",
				values: "15;55;55;55;55;55;55;15;15",
				keyTimes: "0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1",
				repeatCount: "indefinite",
				dur: "2.7027027027027026s",
				attributeName: "x"
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			ry: 3,
			rx: 3,
			height: 30,
			width: 30,
			y: 15,
			x: 15,
			fill: "currentColor",
			children: /* @__PURE__ */ _jsx("animate", {
				begin: "0s",
				values: "85;85;125;125;125;125;85;85;85",
				keyTimes: "0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1",
				repeatCount: "indefinite",
				dur: "2.7027027027027026s",
				attributeName: "x"
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			ry: 3,
			rx: 3,
			height: 30,
			width: 30,
			y: 15,
			x: 15,
			fill: "currentColor",
			children: /* @__PURE__ */ _jsx("animate", {
				begin: "0s",
				values: "155;155;155;195;195;155;155;155;155",
				keyTimes: "0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1",
				repeatCount: "indefinite",
				dur: "2.7027027027027026s",
				attributeName: "x"
			})
		}),
		/* @__PURE__ */ _jsx("g", {})
	] })
});
export default SvgIgpCalculatorLoader;
